export enum PricingMode {
  Trial,
  Production,
  Suspended
}

export interface Pricing {
  mode: PricingMode;
}
